<template>
  <div class="other-setting">
    <div class="content-item" v-if="btnInfo.triggerType === 'SINGLE'">
      <div class="item-title">执行校验流</div>
      <el-radio-group v-model="btnInfo.verifyIsExcute" @change="clearWorkflowId('validateFlowId')">
        <el-radio :label="false">不执行</el-radio>
        <el-radio :label="true">执行</el-radio>
      </el-radio-group>
      <div class="verify" v-if="btnInfo.verifyIsExcute">
        <NormalSelect
          class="subprocess"
          size="normal"
          :selectList="verifyWorkFlows"
          :selectedItem.sync="btnInfo.validateFlowId"
        ></NormalSelect>
        <base-button
          size="normal"
          type="primary"
          style="margin: 0 10px"
          @click="createVerifyWorkFlow('validateFlowId')"
        >
          新建
        </base-button>
        <i
          class="el-icon-link"
          style="color: #409EFF; font-size: 20px"
          @click="toEditFlow(btnInfo.validateFlowId)"
        ></i>
      </div>
    </div>
    <div class="content-item">
      <div class="item-title">启用工作流</div>
      <el-radio-group v-model="btnInfo.flowFlag">
        <el-radio :label="false">不执行</el-radio>
        <el-radio :label="true">执行</el-radio>
      </el-radio-group>
      <div class="setting-content flow-info" v-if="btnInfo.flowFlag">
        <div class="name">
          <span>{{ btnInfo.flowName || "按钮工作流" }}</span>
          <el-tag v-if="!btnInfo.flowEnable" type="info" effect="dark" size="mini">
            禁用
          </el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">启用</el-tag>
        </div>
        <div class="btn-edit pointer" @click="toEditFlow(btnInfo.flowId)">编辑工作流</div>
      </div>
    </div>
    <div class="content-item" v-if="btnInfo.triggerType === 'SINGLE'">
      <div class="item-title">设置</div>
      <el-checkbox v-model="btnInfo.batchEnable" :disabled="batchDisabled" class="item-content">
        批量操作
      </el-checkbox>
    </div>
  </div>
</template>

<script>
import { createWorkflow, getAllWorkflow } from "@/api/workflow/workflow"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import BaseButton from "@/components/UIComponents/Button"

export default {
  name: "other-setting",
  components: { BaseButton, NormalSelect },
  props: {
    btnInfo: Object,
    appId: String
  },
  data() {
    return {
      workflowList: []
    }
  },
  computed: {
    verifyWorkFlows() {
      return this.workflowList
        .filter(
          workFlow =>
            workFlow.trigger?.type === "START_TYPE_VALIDATE" &&
            workFlow.trigger?.sheetId === this.btnInfo.sheetId
        )
        .map(workFlow => ({ label: workFlow.name, value: workFlow.id }))
    },
    batchDisabled() {
      return (
        !(
          (this.btnInfo.actionType !== "FILL" ||
            (this.btnInfo.actionType === "FILL" &&
              this.btnInfo.refCid === "" &&
              this.btnInfo.fillType === "SELF")) &&
          !this.btnInfo.validateFlowId
        ) || ["LIST", "NONE"].includes(this.btnInfo.triggerType)
      )
    }
  },
  watch: {
    batchDisabled: {
      handler(newVal) {
        if (newVal) {
          this.btnInfo.batchEnable = ["LIST", "NONE"].includes(this.btnInfo.triggerType)
        }
      }
    }
  },
  created() {
    this.getWorkflows()
  },
  methods: {
    getWorkflows() {
      return getAllWorkflow(this.appId).then(workflowList => {
        this.workflowList = workflowList
      })
    },
    // 去编辑工作流
    toEditFlow(flowId) {
      localStorage.setItem("btnInfo", JSON.stringify(this.btnInfo))
      this.$router.push({
        name: "admin-edit-workflow",
        query: { id: flowId }
      })
    },
    createVerifyWorkFlow(from) {
      createWorkflow(
        {
          name: "未命名工作流",
          trigger: { type: "START_TYPE_VALIDATE", sheetId: this.btnInfo.sheetId }
        },
        this.appId
      ).then(res => {
        this.getWorkflows().then(() => {
          this.btnInfo[from] = res.data.data.id
        })
      })
    },
    clearWorkflowId(from) {
      this.$set(this.btnInfo, from, "")
    }
  }
}
</script>

<style lang="scss" scoped>
.other-setting {
  .el-radio-group {
    margin-top: 10px;
  }
  .normal-select {
    line-height: 32px;
    min-height: 32px;
    ::v-deep {
      .el-input__inner {
        line-height: 32px;
        min-height: 32px;
      }
      .el-select__tags {
        height: 32px;
      }
    }
  }
  .el-tag {
    margin-left: 6px;
  }
  .verify {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
  .flow-info {
    display: flex;
    .name {
      flex: 1 1;
    }
    .btn-edit {
      color: #2196f3;
    }
  }
  .item-content {
    margin-top: 10px;
  }
}
</style>
